import React, { useEffect, useRef } from 'react';
import ApexCharts from 'apexcharts';

const BarChart = () => {
  const chartRef = useRef(null);

  useEffect(() => {
    const chart = new ApexCharts(chartRef.current, {
      series: [{
        data: [400, 430, 448,  1100, 1200]
      }],
      chart: {
        type: 'bar',
        height: 350
      },
      plotOptions: {
        bar: {
          borderRadius: 4,
          horizontal: true,
        }
      },
      dataLabels: {
        enabled: false
      },
      xaxis: {
        categories: ['Direct Procurement', 'Indirect Procurement', 'Goods', 'Services', 'MRO'
        ],
      }
    });

    chart.render();

    return () => {
      chart.destroy();
    };
  }, []);

  return <div id="barChart" ref={chartRef}></div>;
};

export default BarChart;
